// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-2:c8b8414d-4531-41d0-8f72-1c7335426a95',
    'aws_cognito_region': 'us-east-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'smartpress-hosting-mobilehub-1441946515',
    'aws_content_delivery_bucket_region': 'us-east-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd15ap9oas9ys05.cloudfront.net',
    'aws_google_app_permissions': 'email,profile,openid',
    'aws_google_web_app_id': '805328997457-g1vb3o1ngrfdrfc88to5f6ehspa3in9f.apps.googleusercontent.com',
    'aws_mobile_analytics_app_id': '1a88ac1e12ab4aec977e0306e58b23d2',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '4b6496c9-839e-4966-967a-e239c54b7c86',
    'aws_project_name': 'Smartpress',
    'aws_project_region': 'us-east-2',
    'aws_resource_name_prefix': 'smartpress-mobilehub-1441946515',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-2_6DIl412S8',
    'aws_user_pools_web_client_id': '7t0dju693qr40ap3hiks5lqnn3',
}

export default awsmobile;












// // WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// // Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// // Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// // copy, distribute and modify it.

// // AWS Mobile Hub Project Constants
// const awsmobile = {
//     'aws_app_analytics': 'enable',
//     'aws_cognito_identity_pool_id': 'us-east-2:c8b8414d-4531-41d0-8f72-1c7335426a95',
//     'aws_cognito_region': 'us-east-2',
//     'aws_content_delivery': 'enable',
//     'aws_content_delivery_bucket': 'smartpress-hosting-mobilehub-1441946515',
//     'aws_content_delivery_bucket_region': 'us-east-2',
//     'aws_content_delivery_cloudfront': 'enable',
//     'aws_content_delivery_cloudfront_domain': 'd15ap9oas9ys05.cloudfront.net',
//     'aws_mobile_analytics_app_id': '1a88ac1e12ab4aec977e0306e58b23d2',
//     'aws_mobile_analytics_app_region': 'us-east-1',
//     'aws_project_id': '4b6496c9-839e-4966-967a-e239c54b7c86',
//     'aws_project_name': 'Smartpress',
//     'aws_project_region': 'us-east-2',
//     'aws_resource_name_prefix': 'smartpress-mobilehub-1441946515',
//     'aws_sign_in_enabled': 'enable',
//     'aws_user_pools': 'enable',
//     'aws_user_pools_id': 'us-east-2_6DIl412S8',
//     'aws_user_pools_web_client_id': '7t0dju693qr40ap3hiks5lqnn3',
// }

// export default awsmobile;
